import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DistrictService {
  private apiUrl = environment.apiUrl + '/districts/';
  private http = inject(HttpClient);

  get(): Observable<any> {
    return this.http.get(this.apiUrl + 'get');
  }

  getByPastor(pastorId: string): Observable<any> {
    const params = new HttpParams().set('pastor', pastorId);
    return this.http.get(this.apiUrl + 'get', { params });
  }

  getById(id: string): Observable<any> {
    return this.http.get(this.apiUrl + 'get/' + id);
  }

  save(districtData: any): Observable<any> {
    return this.http.post(this.apiUrl + 'save', districtData);
  }

  update(id: string, districtData: any): Observable<any> {
    return this.http.put(this.apiUrl + 'update/' + id, districtData);
  }

  delete(id: string): Observable<any> {
    return this.http.delete(this.apiUrl + 'delete/' + id);
  }
}
